fragment GoalField on Field {
    name
    type
    filterTitle
    ... on FieldEnum {
        options
    }
}
